import { render, staticRenderFns } from "./assignments.vue?vue&type=template&id=66cc8261"
import script from "./assignments.vue?vue&type=script&lang=js"
export * from "./assignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports